// extracted by mini-css-extract-plugin
module.exports = {"root":"_8b4352"};